import { NOT_ASSIGNED } from 'constants/constants';
import styled from 'styled-components';
import { isArraySingleEmptyValue } from 'util/utils';
import usePcrV2 from '../../hooks/usePcrV2';
import { ComparerRowsGetter } from '../../version-compare/VersionCompareKeyValueGrid';
import { EpdVersionHistoryData } from '../utils/EpdVersionHistoryDataContext';
import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';

const VersionHistoryDataQualityAssessmentGridComments: React.FC<{
  data: EpdVersionHistoryData;
  className?: string;
}> = ({ data, className }) => {
  const isPcrV2 = usePcrV2();
  const dataQualityAssessmentAndReferenceYears = data.dataQualityAssessmentAndReferenceYears;
  // #11472. The users visually can't to figure out whether the empty row is added by default or they forgot to delete empty row, which was added by them before.
  // So it is needed to hide the table if the single entity with empty fields is existed.
  const isOnlySingleEmptyRow =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    isArraySingleEmptyValue(dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems);

  const anyRows =
    dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems.length > 0 &&
    !isOnlySingleEmptyRow;

  const summaryExists =
    !!dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary &&
    (!!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ||
      !!dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary.dataQualityAssessmentComment);

  if (!anyRows && !summaryExists) {
    return null;
  }

  const commentRow = getDataQualityAssessmentCommentRow(data, isPcrV2);

  return commentRow.length > 0 ? (
    <ContentWrapper>
      <VersionHistorySummaryGrid rows={commentRow} />
    </ContentWrapper>
  ) : null;
};

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default VersionHistoryDataQualityAssessmentGridComments;

export const getDataQualityAssessmentCommentRow: ComparerRowsGetter = (
  data: EpdVersionHistoryData,
  isPcrV2: boolean,
  __: any
): SummaryGridRow[] => {
  const commentRow: SummaryGridRow[] = [];
  if (isPcrV2 && data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary?.dataQualityAssessmentComment) {
    commentRow.push({
      ord: 1,
      name: 'Comment on the data sources and other information in the table',
      value:
        data?.dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentComment ??
        NOT_ASSIGNED,
    });
  }
  return commentRow;
};
